import { type App, reactive, readonly } from 'vue';

// Import the global options.
import { preconColorsOptionsInjectionKey } from './symbols';
import {
    type PreconColorsGlobalOptions,
    normalizePreconColorsOptions,
} from './options';

// Export the
export type { PreconColorsGlobalOptions };

// Export the helpers that you want to use outside of this library.
export * from './helpers/normalizeColor';

// Export the composables that you want to use outside of this library.
export * from './composables/useColor';
export * from './composables/useColorClass';
export * from './composables/useColorResolver';
export {
    colorClassResolver,
    bgColorClass,
    textColorClass,
    type ColorClassResolver,
} from './helpers/color-class';

// Import/Export the components that you want to use outside of this library.
// import { default as PreconColorsTitle } from "./components/PreconColorsTitle.vue";
// export { PreconColorsTitle };

// The definition of the plugin that installs the
export default {
    install(app: App, options?: PreconColorsGlobalOptions) {
        /// NORMALIZE THE OPTIONS
        const normalizedOptions = reactive(
            normalizePreconColorsOptions(options ?? {})
        );

        /// INJECT THE OPTIONS
        // This ensures that the options are available to the components in this library.
        app.provide(
            preconColorsOptionsInjectionKey,
            readonly(normalizedOptions)
        );

        /// GLOBAL COMPONENT BINDINGS
        // Use this to register the components that you use almost everywhere in the application.
        // WARNING! Do not register large components like this, as it introduces a significant overhead at the application startup.
        // app.component("PreconColorsTitle", PreconColorsTitle);

        // TODO: Implement the installation of the plugin.
    },
};
